import { ref, watch } from "vue";

// Set this to id to activate goblins 
export const curr_bg = ref(0);

watch(curr_bg,  (v, o) => console.log(v, o));

console.log("Globals???");
console.log(curr_bg);